import {
  Modal,
  PrimaryButton,
  Space,
  TertiaryButton,
  Text,
} from '@procurify/ui'
import { useHistory } from 'react-router'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export interface IAuthenticationRequiredModalProps {
  onStartAuthentication: () => void
}

export const AuthenticationRequiredModal = ({
  onStartAuthentication,
}: IAuthenticationRequiredModalProps) => {
  const intl = useProcurifyIntl()
  const history = useHistory()

  return (
    <Modal open>
      <Modal.Card>
        <Modal.Header>
          {intl.formatMessage(messages.modalHeaderText)}
        </Modal.Header>
        <Modal.Content>
          <Space>
            <Text>{intl.formatMessage(messages.modalMessage)}</Text>

            <Space.Divider />

            <Space direction='horizontal' justify='end'>
              <TertiaryButton onClick={() => history.goBack()}>
                {intl.formatMessage(messages.goBackButtonText)}
              </TertiaryButton>
              <PrimaryButton onClick={onStartAuthentication}>
                {intl.formatMessage(messages.startAuthButtonText)}
              </PrimaryButton>
            </Space>
          </Space>
        </Modal.Content>
      </Modal.Card>
    </Modal>
  )
}
